import { useDispatch, useSelector } from "react-redux";
import {
  ApiCallState,
  isApiCallCompletedSuccessfully,
  isApiCalled,
  isApiCallFailed,
  isApiCallLoading,
} from "src/common/ApiCall";
import { RootState } from "../../../../redux/store";
import { InformationSystemUserGroupActions } from "../../models/system-user-group";

export function useFetchSystemUserGroupsApiCallState(): ApiCallState {
  const { progress, error } = useSelector(
    (rootState: RootState) => rootState.informationSystemUserGroup.systemUserGroupsPEV
  );

  const dispatch = useDispatch();

  function dispatchApiCall(resetApiCall: Boolean) {
    if (!isApiCalled(progress) || resetApiCall) {
      dispatch(InformationSystemUserGroupActions.getAllSystemUserGroups());
    }
  }

  return new ApiCallState(
    isApiCalled(progress),
    isApiCallFailed(error),
    isApiCallLoading(progress),
    isApiCallCompletedSuccessfully(progress, error),
    dispatchApiCall
  );
}
